import axios from '../../axios/index.js'

export default {
    getOptions () {
      return axios.get('/salary_survey/options')
    },
    getList (data) {
      return axios.get(`/salary_survey/list`,{ params: data })
    },
    getCLients (data) {
      return axios.get(`/salary_survey/getCLients`,data)
    },
  }